import React from 'react';
import ProfessionalsAddEmployeeContactInfo from '../../../components/professionals/ProfessionalsAddEmployeeContactInfo';
import { useSubmitAgencyProfessionalContactInfoMutation } from '../../../redux/external-agency';

const AgencyProfessionalsCreateEmployeeContactInfo = ({ handleNavigateToNextStep }) => {
	const [submitContactInfo, { isLoading: isSaving }] = useSubmitAgencyProfessionalContactInfoMutation();

	return (
		<ProfessionalsAddEmployeeContactInfo
			isSaving={isSaving}
			submitForm={submitContactInfo}
			handleNavigateToNextStep={handleNavigateToNextStep}
		/>
	);
};

export default AgencyProfessionalsCreateEmployeeContactInfo;
